import { ComplaintOriginService } from "./../../services/complaint-origin.service";
import { ComplaintOrigin } from "./../../interfaces/complaint-origin";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MessageService, ConfirmationService } from "primeng/api";
import { CommonResponse } from "src/app/interfaces/home";

@Component({
  selector: "app-complaint-origin",
  templateUrl: "./complaint-origin.component.html",
  styleUrls: ["./complaint-origin.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class ComplaintOriginComponent implements OnInit {
  @ViewChild("formWrapper") public formWrapper: ElementRef;
  form: FormGroup;
  editing = false;
  fetching = true;
  complaintOrigins: ComplaintOrigin[];
  selectedComplaintOrigin: ComplaintOrigin;
  cols: any[];
  private complaintOriginToEdit: ComplaintOrigin;

  constructor(
    fb: FormBuilder,
    public messageService: MessageService,
    public complaintOriginService: ComplaintOriginService,
    public confirmationService: ConfirmationService
  ) {
    this.form = fb.group({
      Code: [""],
      Caption: ["", Validators.required],
      Description: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.cols = [
      { field: "code", header: "Code" },
      { field: "caption", header: "Caption" },
      { field: "description", header: "Description" },
    ];
    this.FetchAllComplaintOrigins();
  }

  FetchAllComplaintOrigins() {
    this.complaintOriginService.getAll().subscribe(
      async (compOrigin: CommonResponse) => {
        this.complaintOrigins = compOrigin.responseData;
        this.fetching = false;
      },
      (error) => {
        this.fetching = false;
        this.ConnectionError();
      }
    );
  }

  CreateComplaintOrigin() {
    this.messageService.add({
      severity: "info",
      summary: "Notice",
      detail: "Creating Complaint Origin...",
    });

    const postData: ComplaintOrigin = {
      code: this.form.get("Code").value,
      caption: this.form.get("Caption").value,
      description: this.form.get("Description").value,
    };

    this.complaintOriginService.create(postData).subscribe(
      async () => {
        await this.messageService.add({
          severity: "success",
          summary: "Completed",
          detail: "New Complaint Origin Created...",
        });

        this.FetchAllComplaintOrigins();
        this.form.reset();
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Notice",
          detail:
            "Unable to create complaint origin at the moment.. Reason: [" +
            JSON.stringify(error) +
            "]",
        });
      }
    );
  }

  EditComplaintOrigin(item: ComplaintOrigin) {
    this.editing = true;
    this.form.addControl(
      "ID",
      new FormControl({ value: "", disabled: true }, Validators.required)
    );
    this.complaintOriginToEdit = item;
    this.form.patchValue({
      ID: item.id,
      Code: item.code,
      Caption: item.caption,
      Description: item.description,
    });
    this.formWrapper.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "start",
    });
  }

  UpdateComplaintOrigin() {
    this.messageService.add({
      severity: "info",
      summary: "Notice",
      detail: "Updating Selected Complaint Origin...",
    });
    const id = this.complaintOriginToEdit.id;
    const postData: ComplaintOrigin = {
      code: this.form.get("Code").value,
      caption: this.form.get("Caption").value,
      description: this.form.get("Description").value,
    };
    this.complaintOriginService.update(id, postData).subscribe(
      async () => {
        this.messageService.add({
          severity: "success",
          summary: "Notice",
          detail: "Update Successful!",
        });
        await this.FetchAllComplaintOrigins();
        await this.CloseEditing();
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Unable To Update",
          detail:
            "Unable to update complaint origin at the moment.. Reason: [" +
            JSON.stringify(error) +
            "]",
        });
      }
    );
  }

  DeleteComplaintOrigin(item: ComplaintOrigin) {
    this.confirmationService.confirm({
      message: "Are you sure you want to remove " + item.caption,
      accept: () => {
        this.messageService.add({
          severity: "info",
          summary: "Notice",
          detail: "Removing complaint origin " + item.caption,
        });
        this.complaintOriginService.delete(item.id).subscribe(
          async () => {
            await this.messageService.add({
              severity: "success",
              summary: "Removed",
              detail: item.caption + " removed successfully",
            });
            await this.FetchAllComplaintOrigins();
          },
          (error) => {
            this.ConnectionError();
          }
        );
      },
    });
  }

  CloseEditing() {
    this.editing = false;
    this.form.reset();
    this.complaintOriginToEdit = null;
  }

  private ConnectionError() {
    this.messageService.add({
      severity: "error",
      summary: "Failed",
      detail: "Connection Error, Please try again",
    });
  }
}
